import React from 'react';
import CartItem from './CartItem';
import CheckoutForm from './CheckoutForm';

const Cart = ({
  darkMode,
  cart,
  checkoutStep,
  setCheckoutStep,
  formData,
  handleFormChange,
  handleDeliveryMethodChange,
  handleSubmitOrder,
  removeFromCart,
  updateQuantity,
  calculateTotal,
  calculateDeliveryPrice,
  getPaymentMethod,
  handleCheckout,
  setActiveTab
}) => {
  if (checkoutStep === 1) {
    return (
      <CheckoutForm
        darkMode={darkMode}
        formData={formData}
        handleFormChange={handleFormChange}
        handleDeliveryMethodChange={handleDeliveryMethodChange}
        handleSubmitOrder={handleSubmitOrder}
        setCheckoutStep={setCheckoutStep}
        calculateTotal={calculateTotal}
        calculateDeliveryPrice={calculateDeliveryPrice}
        getPaymentMethod={getPaymentMethod}
      />
    );
  }

  return (
    <>
      <h2 className={`text-xl font-bold mb-4 ${darkMode ? 'text-white' : ''}`}>Корзина</h2>

      {cart.length > 0 ? (
        <>
          {cart.map((item, index) => (
            <CartItem
              key={index}
              item={item}
              index={index}
              removeFromCart={removeFromCart}
              updateQuantity={updateQuantity}
              darkMode={darkMode}
            />
          ))}

          <div className={`rounded-lg shadow p-4 mb-6 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'
            }`}>
            <div className="flex justify-between font-bold text-lg">
              <span>Итого:</span>
              <span>{calculateTotal().toLocaleString()} ₽</span>
            </div>
          </div>

          <button
            onClick={handleCheckout}
            className="w-full py-3 px-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            Оформить заказ
          </button>

          <button
            onClick={() => setActiveTab('selector')}
            className={`w-full py-3 px-4 rounded-lg mt-4 ${darkMode
                ? 'bg-gray-700 text-white hover:bg-gray-600'
                : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
              }`}
          >
            Продолжить покупки
          </button>
        </>
      ) : (
        <div className={`text-center py-8 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
          <i className="fas fa-shopping-cart text-4xl mb-3"></i>
          <p>Ваша корзина пуста</p>
          <button
            onClick={() => setActiveTab('selector')}
            className="mt-4 px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            Перейти к покупкам
          </button>
        </div>
      )}
    </>
  );
};

export default Cart;